<template>
	<!-- Vue Material Progress -->
	<!-- https://vuematerial.io/components/progress -->

	<md-progress-bar
		v-if="type === 'bar'"
		:md-buffer="buffer"
		:md-mode="mode"
		:md-value="value"
		:style="{ height: `${stroke}px` }"
		class="ui-progress-bar"
	/>
	<div
		v-else-if="type === 'dots'"
		class="ui-progress-dots"
	>
		<div class="bounce1"></div>
		<div class="bounce2"></div>
		<div class="bounce3"></div>
	</div>
	<md-progress-spinner
		v-else
		:md-diameter="diameter"
		:md-mode="mode"
		:md-stroke="stroke"
		:md-value="value"
		class="ui-progress-spinner"
	/>
</template>

<script>
export default {
	name: "Progress",
	props: {
		buffer: {
			type: Number,
			default: null, // 0 - 100 (type bar & mode buffer)
			required: false
		},
		diameter: {
			type: Number,
			default: 128,
			required: false
		},
		mode: {
			type: String,
			default: "indeterminate", // determinate, indeterminate (type spinner|bar), query, buffer (type bar)
			required: false
		},
		stroke: {
			type: Number,
			default: 6,
			required: false
		},
		type: {
			type: String,
			default: "spinner", // spinner, bar
			required: false
		},
		value: {
			type: Number,
			default: null, // 0 - 100
			required: false
		}
	}
};
</script>

<style lang="scss" scoped>
	.ui-progress-bar {
		background-color: transparent !important;
		&::before {
			background-color: var(--ui-theme-primary);
			opacity: 0.38;
			content: "";
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
		}
	}
	.ui-progress-dots {
		margin: auto;
		> div {
			background-color: var(--ui-theme-primary);
		}
	}
</style>
